import { useEffect, useState } from "react";

const TARGET = new Date("2026-12-05T10:00:00-05:00").getTime();

const getParts = () => {
  const diff = Math.max(TARGET - Date.now(), 0);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: diff === 0,
  };
};

export const Countdown = () => {
  const [t, setT] = useState(getParts);

  useEffect(() => {
    const id = setInterval(() => setT(getParts()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return (
      <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#DC2626]" data-testid="countdown-live">
        It's show day — gates are open
      </p>
    );
  }

  const cells = [
    { v: t.days, l: "Days" },
    { v: t.hours, l: "Hrs" },
    { v: t.minutes, l: "Min" },
    { v: t.seconds, l: "Sec" },
  ];

  return (
    <div data-testid="countdown-timer" className="flex items-stretch gap-3">
      {cells.map((c) => (
        <div key={c.l} className="clip-badge border border-[#16A34A]/50 bg-black/60 backdrop-blur px-4 py-3 text-center min-w-[72px]">
          <p className="font-display text-3xl sm:text-4xl font-black italic text-white tabular-nums leading-none">
            {String(c.v).padStart(2, "0")}
          </p>
          <p className="mt-1 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-[#22C55E]">{c.l}</p>
        </div>
      ))}
    </div>
  );
};
